export default __webpack_public_path__ + "static/media/Contact_Shapes-01.34ec7a3c.png";